import { anchorType, locationSource, Space } from "types";

export const TABLE_CELL_PADDING = 10;

export const ROWS_PER_PAGE = 500;

export const DEFAULT_STALE_TIME = 60_000;
export const TABLE_REFETCH_INTERVAL = 60_000;

export const FAST_REFRESH_INTERVAL = 5_000;

export const DEFAULT_RETRY = 3;

export const MAX_PAGINATION_STEP = 1000;

export const ANCHOR_TYPES = [
  { id: anchorType.Wifi, name: "Wi-Fi AP" },
  { id: anchorType.Gateway, name: "Luna Device" }
  // { id: anchorType.Luna, name: "Tag" }
];

export const WORKSPACE_LOCATION_SOURCE = [
  { id: locationSource.GpsGateway, name: "Gateway GPS" },
  { id: locationSource.GpsTracker, name: "Tracker GPS" },
  { id: locationSource.Anchor, name: "Wi-Fi AP anchor" },
  { id: locationSource.Gateway, name: "Gateway anchor" },
  { id: locationSource.Auto, name: "Auto Select" }
];

export const DEFAULT_ADMIN_SORT = {
  RA: { field: "name", order: "DESC" as const },
  GRID: { field: "name", sort: "desc" as const }
};

export const DEFAULT_ASSETS_SORT = {
  RA: { field: "name", order: "ASC" as const },
  GRID: { field: "name", sort: "asc" as const }
};

export const DEFAULT_TRACKERS_SORT = {
  RA: { field: "tid", order: "ASC" as const },
  GRID: { field: "tid", sort: "asc" as const }
};

export const AUTH_REDIRECT_TO = `${new URL(window.location.href).origin}/account/update-password`;

export const SSO_REDIRECT_TO = `${new URL(window.location.href).origin}/auth/sso/callback`;

export const AUTH0_LOGOUT_URL = `https://${process.env.NX_AUTH0_DOMAIN}/v2/logout?client_id=${
  process.env.NX_AUTH0_CLIENT_ID
}&returnTo=${encodeURIComponent(new URL(window.location.href).origin)}`;

export const DEFAULT_ZONE_RADIUS = 1;
export const DEFAULT_MAP_KEY = "defaultMap";

export const CURRENT_VERSION = process.env.NX_WEB_VERSION;

// Update CURRENT_LOCALSTORAGE_VERSION to trigger localStorage cleanup for users. Trigger only when adding breaking changes to localStorage.
export const CURRENT_LOCALSTORAGE_VERSION = "1.44.0";

export const GENERIC_API_ERROR =
  "Our system couldn't process your request. Please try again later. If the problem persists, please contact support.";

export const MISSING_DATA_IN_PAYLOAD_ERROR =
  "It seems that some data is missing and we couldn't process your request. Please verify the data and try again. If the problem persists, please contact support.";

export const NO_GEOREFERENCED_IN_PAYLOAD_ERROR =
  "Before saving the site you need to define the georeferenced area.";

export const SITE_MAP_UPLOAD_ERROR = "We couldn't upload the site map file";

export const INVALID_SITE_MAP_PATH_ERROR = "The site map file path is invalid.";

export const ZONE_FILE_INVALID_TYPE = "Invalid file type";

export const ZONE_FILE_INVALID_SVG = "Invalid SVG file. Check if the file contains valid SVG data.";

export const ZONE_FILE_NO_SVG_ELEMENT = "Invalid SVG file. No <svg> element found.";

export const ZONE_FILE_EMPTY_ERROR = "Check if imported file contains valid zones definitions.";

export const ZONE_DEF_WITHOUT_RECT_OR_CIRCLES =
  "The following zones have no rectangle box and classification circles defined:";

export const ZONE_DEF_WITH_CIRCLES_OUTSIDE_RECT =
  "The following zones have centers of classification circles outside of their rectangle box:";

export const MAX_WORKSPACES_SELECTION = 5;
export const MAX_WORKSPACES_SELECTION_MESSAGE = `You can select up to ${MAX_WORKSPACES_SELECTION} workspaces.`;

export const WORKSPACE_SELECTION_SELECT_ALL_KEY =
  "J3rryL1kedT0L00k4tP41nt1ng5Wh1l334t1ngG4rl1c1c3Cr34m";

export const NO_ORG_FOUND =
  "We couldn't find the organization for the current user. Try refreshing the page.";

export const WORKSPACE_SELECTION_ACCESS_ALL_SPACE: Space = {
  id: WORKSPACE_SELECTION_SELECT_ALL_KEY,
  name: "All",
  type: null,
  tags: null,
  meta: null,
  created_at: "",
  created_by: "Jerry",
  updated_at: "",
  updated_by: "Jerry",
  agent: "",
  parent_id: null,
  config: null
};

export const WORKSPACE_SELECTION_SELECT_ALL = [WORKSPACE_SELECTION_ACCESS_ALL_SPACE];

export const LOCALIZED_DATETIME_FORMAT = "L, LTS" as const;
export const LOCALIZED_DATETIME_FORMAT_SHORT = "L, LT" as const;

export const LOCALIZED_DATE_FORMAT = "L" as const;

export const LOCALIZED_TIME_FORMAT = "LTS" as const;
export const LOCALIZED_TIME_FORMAT_SHORT = "LT" as const;

export const LOCALIZED_DATETIME_NO_YEAR = "D MMM, LT" as const;

export const GEOMAN_CONTROLS_ORDER = [
  "drawRectangle",
  "drawPolygon",
  "drawCircle",

  "dragMode",
  "editMode",
  "scaleMode",
  "rotateMode",
  "spitalMode",
  "splitMode",
  "unionMode",
  "cutPolygon",

  "copyLayerMode",
  "removalMode"
];

export const METERS_TO_FEET = 3.28084;

export const EDITOR_MIN_ZOOM = 14;

// Re-export column width constants
export { columnWidths } from "./consts/columnWidths";
